/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";

interface Props {
  IdLeadCorretorSistemaOrigem?: string;
  TipoDeListagem: string;
  CodigoDoLead: string;
}

export function useGetVincularCodigo(props: Props) {
  // const existLead = props.IdLeadCorretorSistemaOrigem
  //   ? `	IdLeadCorretorSistemaOrigem=${props.IdLeadCorretorSistemaOrigem}`
  //   : "";
  const existTipoDeListagem = props.TipoDeListagem
    ? `TipoDeListagem=${props.TipoDeListagem}`
    : "";
  const existCodigoDoLead = props.CodigoDoLead
    ? `&CodigoDoLead=${props.CodigoDoLead}`
    : "";
  const LISTAR_EQUIPES = `/leads/commom/leads/lead-espelho-vendas/v1?${existTipoDeListagem}${existCodigoDoLead}`;
  const fetchData = async () => {
    const response = await instance.get(LISTAR_EQUIPES);
    return response?.data?.data;
  };
  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["get-vincular-codigo"],
    refetchOnWindowFocus: false,
    enabled: false,
    // refetchInterval: 60000,
    retry: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar código do lead. Motivos:\n ${error.response.data.notifications?.map(
          (item: any) => `${item?.message}`
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
